/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceManagementAlertIndicator'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceManagementAlertIndicator'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceManagementAlertIndicatorApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceManagementAlertIndicator);
  }
}(this, function(ApiClient, PerformanceManagementAlertIndicator) {
  'use strict';

  /**
   * PerformanceManagementAlertIndicator service.
   * @module api/PerformanceManagementAlertIndicatorApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceManagementAlertIndicatorApi. 
   * @alias module:api/PerformanceManagementAlertIndicatorApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceManagementAlertIndicatorAddAllPut operation.
     * @callback module:api/PerformanceManagementAlertIndicatorApi~performanceManagementAlertIndicatorAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceManagementAlertIndicator>} body 
     * @param {module:api/PerformanceManagementAlertIndicatorApi~performanceManagementAlertIndicatorAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.performanceManagementAlertIndicatorAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertIndicatorAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertIndicatorAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PerformanceManagementAlertIndicator/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertIndicatorDeleteAllPut operation.
     * @callback module:api/PerformanceManagementAlertIndicatorApi~performanceManagementAlertIndicatorDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/PerformanceManagementAlertIndicatorApi~performanceManagementAlertIndicatorDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertIndicatorDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertIndicatorDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertIndicatorDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlertIndicator/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceManagementAlertIndicatorEditAllPut operation.
     * @callback module:api/PerformanceManagementAlertIndicatorApi~performanceManagementAlertIndicatorEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceManagementAlertIndicator>} body 
     * @param {module:api/PerformanceManagementAlertIndicatorApi~performanceManagementAlertIndicatorEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceManagementAlertIndicatorEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceManagementAlertIndicatorEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceManagementAlertIndicatorEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceManagementAlertIndicator/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
